import { Component, ViewChild, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, merge, OperatorFunction } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';


@Component({
  selector: 'app-typeahead-focus',
  templateUrl: './typeahead-focus.component.html',
  styleUrls: ['./typeahead-focus.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TypeaheadFocusComponent implements OnInit {
  @Input() model: string;
  @Input() data: string[];
  @Input() trackBy: string;
  @ViewChild('instance', { static: true }) instance: NgbTypeahead;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();
  formatter = (result: string) => result.toUpperCase();

  search: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => (term === '' ? this.data
        : this.data.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)).sort())
    );
  };
  constructor() { }

  ngOnInit(): void {
  }

}
